var _g, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallUpdate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1907_671)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#36A6A4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6123 7.65951C13.2949 7.60089 13.0034 7.80342 12.943 8.1132C12.8826 8.42299 13.0858 8.72545 13.3945 8.78607C14.324 8.96728 15.0417 9.68679 15.2236 10.6195V10.6201C15.2754 10.8886 15.5118 11.0838 15.784 11.0838C15.8205 11.0838 15.857 11.0805 15.8942 11.0738C16.2029 11.0119 16.4061 10.7101 16.3457 10.3996C16.0741 9.00659 15.0019 7.93066 13.6123 7.65951Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5707 5.33829C13.422 5.31698 13.2726 5.36095 13.1538 5.45555C13.0316 5.55148 12.9553 5.69005 12.9387 5.84528C12.9035 6.15906 13.1299 6.44287 13.4433 6.47818C15.6044 6.71935 17.2841 8.40286 17.5271 10.5707C17.5596 10.8612 17.8033 11.0804 18.0941 11.0804C18.116 11.0804 18.1373 11.079 18.1592 11.0764C18.3112 11.0597 18.4467 10.9844 18.5423 10.8645C18.6372 10.7446 18.6804 10.5954 18.6631 10.4428C18.3604 7.73798 16.267 5.63875 13.5707 5.33829Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3544 12.6483C14.0138 15.3069 14.6171 12.2311 16.3104 13.9232C17.9428 15.5552 18.881 15.8821 16.8127 17.9498C16.5537 18.158 14.9077 20.6628 9.12299 14.8798C3.3376 9.096 5.84098 7.4483 6.04923 7.1893C8.1225 5.1159 8.44383 6.05959 10.0762 7.69155C11.7695 9.38433 8.69502 9.98961 11.3544 12.6483Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1907_671",
    x: 0,
    y: 0,
    width: 24,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1907_671"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallUpdate);
export default __webpack_public_path__ + "static/media/callUpdate.00313e4450ee57eb64dd97468cb60c30.svg";
export { ForwardRef as ReactComponent };